"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["tag", "className", "spanTitle", "spanClass", "children", "showHr", "align"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".Title--center {\n  text-align: center;\n}\n.Title__hr {\n  border: none;\n  background: #5bbc81;\n  width: 5rem;\n  height: 0.3125rem;\n  margin: 0.5rem 0 0;\n}\n.Title__hr--center {\n  margin: 0.5rem auto 0;\n}\n.Title__hr--left {\n  margin-left: 0;\n}\n.Title__sub_heading {\n  font-weight: 400;\n  display: block;\n}\n.Title__sub_heading.increased_p {\n  font-size: 1.125rem;\n  line-height: 2rem;\n}";
  var fileName = "Title_Title";
  var element = document.querySelector("style[data-sass-component='Title_Title']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var Title = function Title(_ref) {
  var _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? 'h1' : _ref$tag,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$spanTitle = _ref.spanTitle,
    spanTitle = _ref$spanTitle === void 0 ? '' : _ref$spanTitle,
    _ref$spanClass = _ref.spanClass,
    spanClass = _ref$spanClass === void 0 ? '' : _ref$spanClass,
    children = _ref.children,
    _ref$showHr = _ref.showHr,
    showHr = _ref$showHr === void 0 ? false : _ref$showHr,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'left' : _ref$align,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var Tag = tag;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Tag, _objectSpread(_objectSpread({
    className: "Title Title--".concat(align, " ").concat(className)
  }, rest), {}, {
    children: [children, spanTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "Title__sub_heading ".concat(spanClass, " ").concat(tag === 'h1' || tag === 'h2' ? 'increased_p' : ''),
        children: spanTitle
      })
    }), showHr && (tag === 'h1' || tag === 'h2') && /*#__PURE__*/(0, _jsxRuntime.jsx)("hr", {
      className: "Title__hr Title__hr--".concat(align)
    })]
  }));
};
var _default = Title;
exports["default"] = _default;